<template>
  <v-card>
    <v-progress-linear
      v-if="!alert"
      :size="400"
      :width="10"
      color="#1E88E5"
      indeterminate
    ></v-progress-linear>
    <v-card-title class="justify-center">
      <span class="headline">{{ this.title }}</span>
      <v-btn absolute right fab @click="onCloseButtonClick()" small text color="primary">
        <v-icon dark>
          mdi-close-circle
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row no-gutters>
          <v-col md="10" offset-md="1">
            <v-row>
              <v-col md="6" style="max-height: 400px; overflow-y: auto;">
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="member">
                      <h2>
                        <b>Peserta</b>
                      </h2>
                    </label>
                  </div>
                  <v-combobox
                    v-if="!id_subscription"
                    :rules="[rules.required]"
                    id="member"
                    v-model="selectedMember"
                    dense
                    placeholder="Pilih Peserta"
                    class="detail-input__input-text  mr-5"
                    :items="resource.member"
                    :loading="loadingMember"
                    item-text="name"
                    :search-input.sync="searchMember"
                    return-object
                    :disabled="isAdmin"
                    :clearable="!id_subscription"
                    no-data-text="Tidak ditemukan"
                  ></v-combobox>
                  <v-text-field
                    v-else
                    v-model="selectedMember.name"
                    class="detail-input__input-text mr-5"
                    readonly
                  >
                  </v-text-field>
                </div>
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="address">Alamat</label>
                  </div>
                  <v-textarea
                    id="address"
                    v-model="selectedMember.fullAddress"
                    readonly
                    class="detail-input__input-text align-start  mr-5"
                    height="50"
                    outlined
                  />
                </div>
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="nik">NIK</label>
                  </div>
                  <v-text-field
                    id="nik"
                    readonly
                    v-model="selectedMember.nik"
                    dense
                    class="detail-input__input-text mr-5"
                  />
                </div>
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="birthDate"
                      >Tanggal Lahir
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="blink" v-bind="attrs" v-on="on">mdi-information</v-icon>
                        </template>
                        <span>Batas Usia maksimal 70 Tahun 5 Bulan, batas minimal 18 Tahun</span>
                      </v-tooltip>
                    </label>
                  </div>
                  <v-text-field
                    id="birthDate"
                    readonly
                    v-model="selectedMember.birth_date"
                    dense
                    class="detail-input__input-text mr-5"
                  />
                </div>

                <div class="detail-input" v-if="selectedProduct.type.includes('kebakaran')">
                  <div class="detail-input__label">
                    <label for="birthDate">
                      NPWP BMT Pengaju
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="blink" v-bind="attrs" v-on="on">mdi-information</v-icon>
                        </template>
                        <span>Khusus Produk Kebakaran</span>
                      </v-tooltip>
                    </label>
                  </div>
                  <v-text-field
                    id="npwp"
                    readonly
                    v-model="selectedCompany.npwp"
                    dense
                    class="detail-input__input-text mr-5"
                  />
                </div>
                <br />
              </v-col>
              <!-- <v-col md="2"></v-col> -->
              <v-divider vertical></v-divider>
              <v-col md="6">
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="product">
                      <h2>
                        <b>Produk</b>
                      </h2>
                    </label>
                  </div>
                  <!-- v-if="!id_subscription" -->
                  <v-combobox
                    :rules="[rules.required]"
                    id="product"
                    v-model="selectedProduct"
                    dense
                    placeholder="Pilih Produk"
                    class="detail-input__input-text mr-5"
                    :items="resource.product"
                    :loading="loadingProduct"
                    item-text="name"
                    @blur="calculateSubscription()"
                    return-object
                    :disabled="isAdmin"
                    ><template slot="selection" slot-scope="data">
                      <!-- HTML that describe how select should render selected items -->
                      {{ data.item.code }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.code }} - {{ data.item.name }}
                    </template>
                  </v-combobox>
                  <!-- <v-text-field
                    v-else
                    v-model="selectedProduct.code"
                    class="detail-input__input-text mr-5"
                    readonly
                  ></v-text-field> -->
                </div>
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="productName">Nama</label>
                  </div>
                  <v-textarea
                    id="productName"
                    v-model="selectedProduct.name"
                    readonly
                    class="detail-input__input-text align-start  mr-5"
                    height="100"
                    outlined
                  />
                </div>
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="productType">Jenis</label>
                  </div>
                  <v-text-field
                    id="productType"
                    readonly
                    v-model="selectedProduct.type"
                    dense
                    class="detail-input__input-text mr-5"
                  />
                </div>
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="dueMax">Batas Maksimal</label>
                  </div>
                  <v-text-field
                    id="dueMax"
                    readonly
                    v-model="selectedProduct.due_max"
                    dense
                    suffix="Bulan"
                    class="detail-input__input-text mr-5"
                  />
                </div>
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="plafond">Batas Plafond</label>
                  </div>
                  <v-currency-field
                    id="plafond"
                    readonly
                    v-model="selectedProduct.plafond_max"
                    dense
                    prefix="Rp."
                    class="detail-input__input-text mr-5"
                  />
                </div>
              </v-col>
            </v-row>
            <v-col>
              <div>
                <v-alert
                  class="d-flex justify-center"
                  dense
                  transition="scale-transition"
                  :value="alert"
                  :type="alertType"
                >
                  {{ this.alertTitle }}
                  <br v-if="this.alertTitle != ''" />
                  <div class="d-flex justify-center">{{ this.alertMessage }}</div>
                </v-alert>
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-row>
              <v-col md="5">
                <br />
                <div class="detail-input" v-if="selectedProduct.type.includes('kebakaran')">
                  <div class="detail-input__label">
                    <label for="religion"
                      >Objek Usaha
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="blink" v-bind="attrs" v-on="on">mdi-information</v-icon>
                        </template>
                        <span>Khusus Produk Kebakaran</span>
                      </v-tooltip>
                    </label>
                  </div>
                  <v-text-field
                    :readonly="isAdmin"
                    id="bussinesInsurance"
                    v-model="input.bussines.insurance"
                    dense
                    required
                    :loading="loading"
                    placeholder="Pilih Objek Pertanggungan"
                    class="detail-input__input-text"
                    @blur="alertMsg()"
                  ></v-text-field>
                </div>
                <div class="detail-input" v-if="selectedProduct.type.includes('kebakaran')">
                  <div class="detail-input__label">
                    <label for="businessAddress"
                      >Alamat Lengkap Usaha
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="blink" v-bind="attrs" v-on="on">mdi-information</v-icon>
                        </template>
                        <span>Khusus Produk Kebakaran</span>
                      </v-tooltip>
                    </label>
                  </div>
                  <v-text-field
                    :readonly="isAdmin"
                    id="businessAddress"
                    v-model="input.bussines.address"
                    dense
                    placeholder="Masukkan Alamat Usaha"
                    class="detail-input__input-text"
                    required
                    :loading="loading"
                    @blur="alertMsg()"
                  />
                </div>
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="iplafond">Plafond</label>
                  </div>
                  <v-currency-field
                    :readonly="isAdmin"
                    :rules="[rules.required]"
                    @keypress="onlyNumber"
                    id="iplafond"
                    v-model="input.plafond"
                    prefix="Rp."
                    dense
                    placeholder="Masukkan Pembiayaan"
                    class="detail-input__input-text"
                    :loading="loading"
                    @blur="
                      alertMsg()
                      calculateSubscription()
                    "
                  />
                </div>

                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="periode">Jangka Waktu</label>
                  </div>
                  <v-text-field
                    :readonly="isAdmin"
                    :rules="[rules.required]"
                    @keypress="onlyNumber"
                    id="periode"
                    v-model="input.periode"
                    suffix="Bulan"
                    dense
                    placeholder="Masukkan Jangka Waktu"
                    class="detail-input__input-text"
                    required
                    :loading="loading"
                    @input="enforcePeriodeLimit()"
                    @blur="
                      alertMsg()
                      calculateSubscription()
                    "
                  />
                </div>
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="disbursement">Tanggal Akad</label>
                  </div>

                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="input.disbursement"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    :disabled="isAdmin"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :rules="[rules.required]"
                        id="disbursement"
                        dense
                        placeholder="Masukkan Tanggal Akad"
                        class="detail-input__input-text"
                        required
                        readonly
                        :clearable="!isAdmin"
                        :loading="loading"
                        v-bind="attrs"
                        v-on="on"
                        :value="disbursementFormattedMomentjs"
                        @click:clear="input.disbursement = ''"
                        @blur="calculateSubscription()"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      @click:date="
                        $refs.menu.save(input.disbursement)
                        menu = false
                        calculateSubscription()
                        alertMsg()
                      "
                      v-model="input.disbursement"
                      :min="minDisbursementDate"
                      :max="maxDisbursementDate"
                      locale="id-ID"
                      no-title
                      scrollable
                      :disabled="isAdmin"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
              <v-col md="2">
                <div class="label-header">
                  <label>
                    <h3>
                      <b>Pembiayaan</b>
                    </h3>
                  </label>
                </div>
              </v-col>
              <v-col md="5">
                <br />

                <div class="tariff-table" v-if="tariffRows.length > 1">
                  <div class="tariff-table__row tariff-table__row--head">
                    <span>Tarif Iuran</span>
                    <span>Jumlah</span>
                  </div>
                  <div class="tariff-table__row" v-for="row in tariffRows" :key="`tariff-${row.year}`">
                    <span>{{ row.rowLabel }}</span>
                    <span>{{ getCurrency(row.nominal) }}</span>
                  </div>
                </div>
                <template v-else>
                  <div class="detail-input">
                    <div class="detail-input__label">
                      <label for="tariffPercent">Tarif Iuran</label>
                    </div>
                    <v-text-field
                      id="tariffPercent"
                      readonly
                      :loading="tariffSimulation.loading"
                      :value="tariffRows[0].percent"
                      dense
                      suffix="%"
                      class="detail-input__input-text"
                    />
                  </div>
                  <div class="detail-input">
                    <div class="detail-input__label">
                      <label for="tariffNominal">Jumlah Iuran</label>
                    </div>
                    <v-currency-field
                      id="tariffNominal"
                      readonly
                      :loading="tariffSimulation.loading"
                      :value="tariffRows[0].nominal"
                      dense
                      prefix="Rp."
                      class="detail-input__input-text"
                    />
                  </div>
                </template>
                <div class="detail-input" v-if="tariffRows.length > 1">
                  <div class="detail-input__label">
                    <label for="tariffTotalNominal">Total Iuran</label>
                  </div>
                  <v-currency-field
                    id="tariffTotalNominal"
                    readonly
                    :loading="tariffSimulation.loading"
                    :value="tariffTotal.nominal"
                    dense
                    prefix="Rp."
                    class="detail-input__input-text"
                  />
                </div>
                <div class="detail-input">
                  <div class="detail-input__label">
                    <label for="dueDate">Jatuh Tempo</label>
                  </div>
                  <v-text-field
                    id="dueDate"
                    readonly
                    v-model="dueFormattedMomentjs"
                    dense
                    class="detail-input__input-text"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12"> </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="isSaveDisable" color="secondary" width="100" text large @click="onCloseButtonClick()">
        Kembali
      </v-btn>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingSave"
            v-if="!isAdmin && isSave"
            v-bind="attrs"
            v-on="on"
            :color="!save ? 'red' : 'primary'"
            width="100"
            @click="saveSubscription()"
            large
          >
            Simpan
          </v-btn>
        </template>
        <span>{{ !save ? 'Isi data dengan lengkap!' : 'Tercover' }}</span>
      </v-tooltip>
    </v-card-actions>
  </v-card>
</template>

<script>
import Swal from 'sweetalert2'
import Constant from '@/const'

import ConstantMixin from '@/constantMixin'

const _ = require('lodash')
const axios = require('axios')
const moment = require('moment')

export default {
  mixins: [ConstantMixin],
  props: {
    id_subscription: String,
    id_company: String,
    id_member: String,
    isSave: Boolean
  },
  data: () => ({
    title: 'Daftar Iuran Peserta',
    loading: false,
    loadingMember: false,
    loadingProduct: false,
    loadingSave: false,
    dialog: false,
    dialogDelete: false,
    activeRadio: '',
    alert: false,
    alertType: 'success',
    alertMessage: 'ok',
    alertTitle: '',
    isNew: true,
    isAdmin: false,
    menu: false,
    save: false,
    isSaveDisable: false,
    input: {
      id_company: '',
      id_member: '',
      id_product: '',
      isDemo: false,
      plafond: '',
      disbursement: '',
      periode: '',
      due_date: '',
      tariff: {
        percent: 0,
        nominal: 0
      },
      paidStatus: [],
      claimStatus: [],
      timestamps: {
        created_by: ''
      },
      bussines: {
        address: '',
        insurance: ''
      }
    },
    rules: {
      required: value => !!value || 'Harus di isi!',
      plafond: () => {}
    },
    selectedMember: '',
    selectedProduct: {
      name: '',
      type: ''
    },
    // Hasil simulasi iuran dari Backend untuk produk non-flat. `data` null selama
    // belum ada hasil yang sah — entah karena datanya belum lengkap, masih dimuat,
    // atau permintaannya ditolak — supaya nominal lama tidak ikut tersimpan.
    tariffSimulation: {
      loading: false,
      error: '',
      data: null
    },
    selectedCompany: '',
    searchMember: '',
    resource: {
      member: [],
      product: [],
      bussinesInsurance: []
    }
  }),
  created() {},
  computed: {
    // Produk non-flat memakai tabel tarif per usia (age_tariff), bukan due_year yang
    // sama untuk semua peserta. Kalau field isFlatRate tidak ada di response — produk
    // lama atau response yang tidak lengkap — keberadaan age_tariff yang menentukan,
    // supaya tarif tidak diam-diam jatuh ke due_year milik produk non-flat (0).
    isFlatRateProduct() {
      const ageTariff = _.get(this.selectedProduct, 'age_tariff', [])
      return _.get(this.selectedProduct, 'isFlatRate', ageTariff.length === 0)
    },
    // Kunci permintaan simulasi: berubah berarti angka iuran di layar sudah basi dan
    // harus diambil ulang dari Backend. String kosong berarti simulasi belum bisa
    // diminta — produk bertarif tunggal (Backend tidak menghitungnya) atau ada data
    // wajib yang belum diisi. Tanggal akad termasuk wajib karena Backend memakainya
    // untuk menentukan usia peserta saat akad.
    tariffSimulationKey() {
      if (this.isFlatRateProduct) return ''

      const idProduct = _.get(this.selectedProduct, '_id', '')
      const idMember = _.get(this.selectedMember, '_id', '')
      const plafond = Number(this.input.plafond) || 0
      const periode = Number(this.input.periode) || 0
      const disbursement = this.input.disbursement || ''

      if (!idProduct || !idMember || !plafond || !periode || !disbursement) return ''
      return [idProduct, idMember, plafond, periode, disbursement].join('|')
    },
    // Baris iuran per tahun kontrak. Produk non-flat memakai hasil endpoint simulasi
    // Backend apa adanya — rumus tarif usianya hidup di sana saja. Layar tidak boleh
    // menghitungnya sendiri karena usia yang dipakai adalah usia peserta pada TANGGAL
    // AKAD, bukan usia hari ini, sehingga akad yang bukan hari ini bisa menggeser baris
    // tarifnya satu tingkat usia.
    //
    // Produk bertarif tunggal tetap dihitung di layar: Backend tidak menyimulasikannya.
    tariffSchedule() {
      const periode = Number(this.input.periode) || 0
      const plafond = Number(this.input.plafond) || 0
      if (!periode || !plafond) return []

      if (this.isFlatRateProduct) {
        const percent = _.get(this.selectedProduct, 'due_year', 0)
        return [
          {
            year: 1,
            age: null,
            month: periode,
            percent,
            nominal: Math.round(plafond * (periode / 100) * percent)
          }
        ]
      }

      // `months` dinamai `month` supaya bentuk barisnya sama dengan jalur produk flat
      // dan pemakainya tidak perlu tahu angkanya datang dari mana.
      return _.get(this.tariffSimulation.data, 'tariff_yearly', []).map(row => ({
        year: row.year,
        age: row.age,
        month: row.months,
        percent: row.percent,
        nominal: row.nominal
      }))
    },
    // Baris siap tampil. Satu baris memakai nilai dari input.tariff supaya tampilan
    // produk lain tidak berubah sama sekali; beberapa baris ditampilkan sebagai tabel
    // dengan keterangan tahun, usia yang dipakai tarifnya, dan jumlah bulan bila tidak
    // genap setahun.
    tariffRows() {
      const rows = this.tariffSchedule
      if (rows.length < 2) {
        return [{ year: 1, percent: this.input.tariff.percent, nominal: this.input.tariff.nominal }]
      }

      return rows.map(row => {
        const note = [`${row.age} th`]
        if (row.month !== 12) note.push(`${row.month} bln`)
        return { ...row, rowLabel: `Tahun ${row.year} (${note.join(', ')})` }
      })
    },
    // Yang disimpan tetap satu angka total terhadap plafond. Produk non-flat memakai
    // field `tariff` dari simulasi, yang sudah berisi total seluruh jangka waktu —
    // bukan jumlahan `tariff_yearly`, supaya yang tersimpan sama persis dengan yang
    // dihitung Backend. 0 selama hasil simulasinya belum ada; alertMsg() yang menahan
    // penyimpanannya.
    tariffTotal() {
      const rows = this.tariffSchedule

      if (this.isFlatRateProduct) {
        if (!rows.length) return { percent: 0, nominal: 0 }

        return {
          percent: Math.round(_.sumBy(rows, 'percent') * 1e8) / 1e8,
          nominal: _.sumBy(rows, 'nominal')
        }
      }

      const tariff = _.get(this.tariffSimulation.data, 'tariff')
      if (!tariff) return { percent: 0, nominal: 0 }

      return { percent: tariff.percent, nominal: tariff.nominal }
    },
    // Rincian setoran per tahun untuk dikirim ke Backend. Tanggal tiap baris diturunkan
    // dari tanggal akad: baris ke-n mulai 12 bulan setelah baris sebelumnya dan jatuh
    // tempo sejumlah bulan baris itu, sehingga Backend bisa memakainya langsung sebagai
    // jadwal pembayaran ke-1/2/3. Tanggal dikosongkan selama tanggal akad belum diisi —
    // saat itu simpan juga masih ditahan.
    tariffSchedulePayload() {
      const disbursement = this.input.disbursement ? moment(this.input.disbursement) : null

      return this.tariffSchedule.map(row => {
        const start = disbursement ? disbursement.clone().add((row.year - 1) * 12, 'month') : null

        return {
          payment_order: row.year,
          age: row.age,
          month: row.month,
          percent: row.percent,
          nominal: row.nominal,
          start_date: start ? start.format() : '',
          due_date: start
            ? start
                .clone()
                .add(row.month, 'month')
                .format()
            : ''
        }
      })
    },
    // Produk non-flat hanya boleh disimpan setelah nominalnya datang dari Backend.
    // Selama masih dimuat, ditolak, atau datanya belum lengkap, nominalnya 0 dan
    // penyimpanan ditahan supaya iuran tidak tersimpan dengan angka tebakan.
    isTariffReady() {
      if (this.isFlatRateProduct) return true

      return this.tariffTotal.nominal > 0
    },
    disbursementFormattedMomentjs() {
      return this.input.disbursement
        ? moment(this.input.disbursement)
            .locale('id')
            .format('D MMMM YYYY')
        : ''
    },
    minDisbursementDate() {
      return moment()
        .subtract(60, 'days')
        .format('YYYY-MM-DD')
    },
    maxDisbursementDate() {
      return moment().format('YYYY-MM-DD')
    },
    dueFormattedMomentjs() {
      return this.input.due_date
        ? moment(this.input.due_date)
            .locale('id')
            .format('D MMMM YYYY')
        : ''
    }
  },
  watch: {
    // 'resource.member': function(val) {
    //
    //   if (this.id_subscription) this.getSubscription()
    // },
    // 'resource.product': function(val) {
    //
    //   if (this.id_subscription) this.getSubscription()
    // },
    selectedMember: function(val) {
      if (!val) this.selectedMember = ''
      else this.input.id_member = this.selectedMember._id
      // Tarif produk non-flat ikut usia peserta, jadi ganti peserta harus menghitung
      // ulang iuran — bukan hanya saat jangka waktu/plafond/produk berubah.
      this.calculateSubscription()
      this.alertMsg()
    },
    selectedProduct: function() {
      this.input.id_product = this.selectedProduct._id
      // Ganti produk bisa membuat jangka waktu yang sudah diisi melebihi batas produk
      // yang baru, jadi dipangkas sebelum iuran dihitung ulang.
      this.enforcePeriodeLimit()
      this.calculateSubscription()
      this.alertMsg()
    },
    searchMember(val) {
      if (val) this.searchData(this)
      else this.resource.member = []
    },
    // Satu pintu untuk semua pemicu simulasi — produk, peserta, plafond, jangka waktu,
    // tanggal akad — supaya tidak ada jalur masuk yang terlewat, termasuk saat form
    // diisi dari data yang sudah tersimpan.
    tariffSimulationKey: function(val) {
      this.tariffSimulation.data = null
      this.tariffSimulation.error = ''
      this.tariffSimulation.loading = !!val

      if (!val) {
        this.calculateSubscription()
        this.alertMsg()
        return
      }

      // loading dinyalakan sejak sekarang, bukan setelah jeda, supaya layar tidak
      // sempat memperlihatkan nominal lama sebagai angka yang sudah final.
      this.requestTariffSimulation(this)
    }
  },
  async mounted() {
    if (_.toLower(this.$store.getters.userLoggedIn.role) == 'administrator') this.isAdmin = true
    // this.getMember()
    if (this.id_subscription != '') {
      this.title = 'Ubah Iuran Peserta'
      this.isNew = false
      this.getSubscription()
    } else {
      this.input.id_company = this.$store.getters.userLoggedIn.company.id
    }
    this.getProduct()
    this.input.timestamps.created_by = this.$store.getters.userLoggedIn.id
    this.getCompany()
    this.alertMsg()
    this.input.isDemo = this.isDemo
  },
  methods: {
    searchData: _.debounce(v => {
      v.getMember()
    }, 650),
    setAlert(alert, type, msg, title) {
      this.alertType = type
      this.alert = alert
      this.alertMessage = msg
      this.alertTitle = title || ''
    },
    alertMsg() {
      if (this.isSave) {
        this.save = false
        this.setAlert(false, 'success', '')
        if (!this.selectedMember || !this.selectedProduct) {
          if (!this.selectedMember) this.setAlert(true, 'info', 'Pilih Peserta')
          if (!this.selectedProduct) this.setAlert(true, 'info', 'Pilih Produk')
          if (!this.selectedMember && !this.selectedProduct)
            this.setAlert(true, 'info', 'Pilih Peserta dan Produk')
        } else {
          if (this.selectedMember.age >= 70)
            if (this.selectedMember.age == 70 && this.selectedMember.ageMonth < 6) {
            } else {
              return this.setAlert(true, 'error', 'Peserta sudah berusia lebih dari 70 tahun 5 bulan')
            }

          if (this.selectedMember.age < 18)
            return this.setAlert(true, 'error', 'Peserta belum berusia 18 tahun')

          // Penolakan simulasi ditampilkan apa adanya: Backend yang tahu alasannya,
          // misalnya usia peserta di luar tabel tarif produk.
          if (this.tariffSimulation.error) return this.setAlert(true, 'error', this.tariffSimulation.error)

          if (this.selectedProduct.type.includes('kebakaran')) {
            let message = []
            // if (!this.selectedCompany.npwp) message.push('NPWP BMT')

            if (message.length > 0) {
              return this.setAlert(
                true,
                'error',
                `Data belum tersedia: ${message.join(', ')}. Silahkan lengkapi data Peserta terlebih dahulu.`
              )
            }
          }

          const message = []
          if (
            !this.input.periode ||
            !this.input.plafond ||
            !this.input.disbursement ||
            (this.selectedProduct.type.includes('kebakaran') && !this.input.bussines.insurance) ||
            (this.selectedProduct.type.includes('kebakaran') && !this.input.bussines.address)
          ) {
            if (!this.input.periode) message.push('Jangka Waktu')
            if (!this.input.plafond) message.push('Plafond')
            if (!this.input.disbursement) message.push('Tanggal Akad')

            if (this.selectedProduct.type.includes('kebakaran')) {
              if (!this.input.bussines.insurance) message.push('Objek Usaha')
              if (!this.input.bussines.address) message.push('Alamat Usaha')
            }

            this.setAlert(true, 'warning', `Silahkan Lengkapi data ${message.join(', ')}`)
          }

          let plafond = this.selectedMember.plafond

          // Batas bawah diambil dari produk, bukan angka tetap: produk lama memakai
          // plafond_min 0 dan due_min 3 sehingga perilakunya tidak berubah, sedangkan
          // produk seperti 303 punya plafond minimal dan jangka waktu minimal sendiri.
          const plafondMin = _.get(this.selectedProduct, 'plafond_min', 0)
          const dueMin = _.get(this.selectedProduct, 'due_min', 3)

          let isPlafond =
            (this.id_subscription ? 0 : this.input.plafond) + plafond <= this.selectedProduct.plafond_max

          // Plafond dan jangka waktu yang masih kosong dianggap lolos di sini supaya
          // pesannya tetap 'Silahkan Lengkapi data', bukan peringatan batas minimal.
          // Penyimpanan tetap ditahan isInput.
          let isPlafondMin = !this.input.plafond || this.input.plafond >= plafondMin

          let isPeriode = this.input.periode <= this.selectedProduct.due_max && this.input.periode >= dueMin

          let isInput = !!this.input.plafond && !!this.input.disbursement && !!this.input.periode
          let title = ''

          // if (this.selectedProduct.type.includes('kebakaran')) {
          //   if (!this.input.bussines.insurance) {
          //     this.setAlert(true, 'error', 'Objek Usaha harus diisi', title)
          //   }
          //   if (!this.input.bussines.address) {
          //     this.setAlert(true, 'error', 'Alamat Usaha harus diisi', title)
          //   }
          // }
          if (plafond > 0) {
            title = `Peserta memiliki plafond ${this.getCurrency(plafond)}`
            this.setAlert(true, 'warning', `Silahkan Lengkapi data ${message.join(', ')}`, title)
          }

          if (isPlafond && isPlafondMin && isPeriode && isInput && this.isTariffReady) {
            if (this.selectedProduct.type.includes('kebakaran'))
              if (!this.input.bussines.insurance || !this.input.bussines.address) return
            this.save = true
            this.setAlert(true, 'success', 'Tercover!', title)
          }
          //  else if (!isPlafond && !isPeriode)
          //   this.setAlert(true, 'error', 'Plafond dan/atisPlafondau Periode Tidak Sesuai!', title)
          else if (this.selectedProduct.plafond_max && !isPlafond)
            this.setAlert(true, 'error', 'Plafond Melebihi Batas!', title)
          else if (!isPlafondMin)
            this.setAlert(true, 'error', `Plafond Minimal ${this.getCurrency(plafondMin)}`, title)
          else if (!isPeriode && this.input.periode > 0) {
            if (this.input.periode > this.selectedProduct.due_max)
              this.setAlert(true, 'error', 'Jangka Waktu Melebihi Batas!', title)
            if (this.input.periode < dueMin)
              this.setAlert(true, 'error', `Jangka Waktu Minimal ${dueMin} Bulan`, title)
          }
        }
      } else {
        this.setAlert(true, 'success', 'Tercover!')
      }
    },

    // Jangka waktu dipangkas ke batas maksimal produk supaya iuran tidak terlanjur
    // dihitung dari angka yang tidak mungkin dijual. Dipasang di event input, bukan
    // keypress, karena keypress berjalan sebelum karakternya masuk ke v-model sehingga
    // pengecekannya selalu tertinggal satu ketikan; input juga ikut menangkap paste.
    enforcePeriodeLimit() {
      const dueMax = _.get(this.selectedProduct, 'due_max', 0)
      if (!dueMax || !this.input.periode) return
      if (Number(this.input.periode) <= dueMax) return

      this.input.periode = dueMax
      this.swalToast('warning', `Jangka waktu melebihi batas, disesuaikan menjadi ${dueMax} bulan`)
    },
    // Payload simpan. Produk non-flat menyertakan rincian setoran per tahun
    // (tariff_schedule) karena iurannya disetor ke pihak ketiga per 12 bulan dengan
    // tarif usia yang berbeda tiap tahun; field tariff lama tetap dikirim berisi
    // totalnya supaya Backend bisa menyesuaikan bertahap. Produk flat payload-nya tidak
    // berubah sama sekali.
    buildSubscriptionPayload() {
      if (this.isFlatRateProduct) return this.input

      return { ...this.input, tariff_schedule: this.tariffSchedulePayload }
    },
    // Jeda supaya mengetik plafond atau jangka waktu tidak memanggil Backend tiap
    // karakter. Lamanya mengikuti pencarian peserta di berkas ini.
    requestTariffSimulation: _.debounce(v => {
      v.fetchTariffSimulation()
    }, 650),
    // Mengambil nominal iuran dari Backend. Tanggal akad dikirim sebagai tanggal
    // kalender tanpa zona waktu: ia menentukan usia peserta saat akad, dan menyertakan
    // offset zona waktu berisiko menggesernya sehari sehingga usianya ikut bergeser.
    fetchTariffSimulation() {
      const key = this.tariffSimulationKey
      if (!key) return

      const idProduct = _.get(this.selectedProduct, '_id', '')

      this.runApiCalls(() => {
        axios
          .get(Constant.apiUrl.concat(`/product/${idProduct}/tariff-simulation`), {
            params: {
              plafond: Number(this.input.plafond),
              periode: Number(this.input.periode),
              id_member: _.get(this.selectedMember, '_id', ''),
              disbursement: moment(this.input.disbursement).format('YYYY-MM-DD')
            }
          })
          .then(response => {
            // Jawaban yang datang setelah datanya berubah lagi dibuang: permintaan
            // terakhirlah yang mewakili keadaan layar sekarang.
            if (this.tariffSimulationKey !== key) return

            this.tariffSimulation.data = _.get(response, 'data.data', null)
            this.tariffSimulation.error = ''
            this.tariffSimulation.loading = false
            this.calculateSubscription()
            this.alertMsg()
          })
          .catch(error => {
            if (this.tariffSimulationKey !== key) return

            this.tariffSimulation.data = null
            this.tariffSimulation.error = _.get(
              error,
              'response.data.pesan',
              'Tidak dapat menghitung iuran, silahkan coba lagi'
            )
            this.tariffSimulation.loading = false
            this.calculateSubscription()
            this.alertMsg()
          })
      })
    },
    calculateSubscription() {
      if (this.input.periode && this.input.plafond) {
        this.input.tariff.percent = this.tariffTotal.percent
        this.input.tariff.nominal = this.tariffTotal.nominal
      }
      if (this.input.disbursement && this.input.periode) {
        this.input.due_date = moment(this.input.disbursement)
          .add(this.input.periode, 'month')
          .format()
      }
    },
    getCompany() {
      if (this?.input?.id_company) {
        axios.get(Constant.apiUrl.concat(`/master/company/${this.input.id_company}`)).then(response => {
          if (response.status === 200) {
            this.selectedCompany = response.data.data
          } else {
            this.selectedCompany = ''
          }
        })
      }
    },
    getMember(id_member) {
      if (!this.searchMember) {
        this.resource.member = []
        return
      }
      this.loadingMember = true
      let uri = Constant.apiUrl.concat(
        '/member?company=',
        this.id_company || this.$store.getters.userLoggedIn.company.id,
        '&search=',
        this.searchMember || ''
      )

      if (id_member) uri = Constant.apiUrl.concat('/member/', id_member)

      axios
        .get(uri)
        .then(response => {
          if (response.status === 200) {
            let resData = response.data.data
            if (id_member) resData = [resData]

            this.resource.member = resData.map(r => {
              let member = r
              let age = moment().diff(member.birth_date, 'year')
              const ageMonth = moment().diff(member.birth_date, 'months') % 12
              member.age = age
              member.fullAddress = r.address.description
              member.ageMonth = ageMonth
              member.birth_date = moment(member.birth_date)
                .locale('id')
                .format('D MMMM YYYY')
                .concat(` (${age} Tahun, ${ageMonth} Bulan)`)
              member.name = member.name.concat(` (${member.nik})`)
              return member
            })
            if (id_member) this.selectedMember = this.resource.member[0]
            this.loadingMember = false
          } else {
            this.resource.member = []
            this.loadingMember = false
          }
        })
        .catch(error => {
          this.resource.member = []
          this.loadingMember = false
          // this.swalToast('error', `${this.searchMember} tidak ditemukan`)
        })
    },
    getProduct() {
      this.loadingProduct = true
      axios.get(Constant.apiUrl.concat('/product/active?sort=code')).then(response => {
        if (response.status === 200) {
          const resData = response.data.data
          this.resource.product = resData.map(r => {
            return r
          })
          this.loadingProduct = false
        } else {
          this.resource.product = []
          this.loadingProduct = false
        }
      })
    },
    async getSubscription() {
      try {
        this.loading = true
        await axios.get(Constant.apiUrl.concat('/subscription/', this.id_subscription)).then(response => {
          const subscription = response.data.data
          this.input.id_company = subscription?.id_company
          this.input.id_member = subscription?.id_member
          this.input.id_product = subscription?.id_product
          this.input.plafond = subscription?.plafond
          this.input.disbursement = subscription?.disbursement
          this.input.due_date = subscription?.due_date
          this.input.periode = subscription?.periode
          this.input.bussines = {
            insurance: subscription?.bussines?.insurance,
            address: subscription?.bussines?.address
          }
          this.getCompany()
          this.selectedMember = {
            ...subscription?.member,
            fullAddress: subscription?.member?.address?.description,
            age: moment().diff(subscription?.member?.birth_date, 'year'),
            ageMonth: moment().diff(subscription?.member?.birth_date, 'months') % 12,
            birth_date: moment(subscription?.member?.birth_date)
              .locale('id')
              .format('D MMMM YYYY')
              .concat(
                ` (${moment().diff(subscription?.member?.birth_date, 'year')} Tahun, ${moment().diff(
                  subscription?.member?.birth_date,
                  'month'
                ) % 12} Bulan)`
              )
          }

          this.selectedProduct = subscription?.product

          // for (const member of this.resource.member) {
          //   if (this.input.id_member == member._id) {
          //     this.selectedMember = member
          //   }
          // }
          // for (const product of this.resource.product) {
          //   if (this.input.id_product == product._id) {
          //     this.selectedProduct = product
          //   }
          // }
          this.calculateSubscription()
          this.loading = false
        })
      } catch (error) {
        this.loading = false
      }
    },

    saveSubscription() {
      Swal.fire({
        title: 'Pendaftaran Iuran Peserta Akan diproses',
        text: `Pastikan data yang diisi sudah benar, jika ada kesalahan data, silahkan ubah data terlebih dahulu`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      })
        .then(result => {
          if (result.value) {
            this.swalLoading()
            this.saveSubscriptionHelper()
          }
        })
        .catch(error => {
          if (error.response) {
            const message = error.response.data.pesan
            Swal.fire({
              icon: 'error',
              title: 'Terjadi Kesalahan',
              text: message
            })
          } else if (error.request) {
            Swal.fire({
              icon: 'error',
              title: 'Terjadi Kesalahan',
              text: 'Tidak dapat menyambung ke server'
            })
          } else {
            // eslint-disable-next-line
            console.log('Something happened in the middle of request')
          }
        })
    },

    saveSubscriptionHelper() {
      try {
        if (this.save && !this.isSaveDisable && !this.loadingSave) {
          this.loadingSave = true
          this.isSaveDisable = true
          this.input.disbursement = moment(this.input.disbursement).format()
          this.input.due_date = moment(this.input.due_date).format()
          this.swalLoading()
          if (!this.id_subscription) {
            this.runApiCalls(() => {
              axios
                .post(Constant.apiUrl.concat('/subscription/register'), this.buildSubscriptionPayload())
                .then(response => {
                  if (response.status === 200) {
                    this.$socket.client.emit('subscription:update', {
                      company: this.$store.getters.userLoggedIn.company.name,
                      staff: this.$store.getters.userLoggedIn
                    })
                    // Swal.fire('Berhasil', 'Data Iuran Peserta Berhasil Disimpan', 'success')
                    this.swalToast('success', 'Data Iuran Peserta Berhasil Disimpan')
                    this.onCloseButtonClick()
                  }
                })
                .catch(error => {
                  if (error.response) {
                    const message = error.response.data.pesan
                    Swal.fire({
                      icon: 'error',
                      title: 'Terjadi Kesalahan',
                      text: message
                    })
                  } else if (error.request) {
                    Swal.fire({
                      icon: 'error',
                      title: 'Terjadi Kesalahan',
                      text: 'Tidak dapat menyambung ke server'
                    })
                  } else {
                    // eslint-disable-next-line
                    console.log('Something happened in the middle of request')
                  }
                })
                .finally(() => {
                  this.loadingSave = false
                })
            })
          } else {
            this.runApiCalls(() => {
              axios
                .put(
                  Constant.apiUrl.concat('/subscription/', this.id_subscription),
                  this.buildSubscriptionPayload()
                )
                .then(response => {
                  if (response.status === 200) {
                    this.$socket.client.emit('subscription:update', {
                      company: this.$store.getters.userLoggedIn.company.name,
                      staff: this.$store.getters.userLoggedIn
                    })
                    this.onCloseButtonClick()
                    // Swal.fire('Berhasil', 'Data Subscription Berhasil Perbarui', 'success')
                    this.swalToast('success', 'Data Subscription Berhasil Perbarui')
                  }
                })
                .catch(error => {
                  if (error.response) {
                    const message = error.response.data.pesan
                    Swal.fire({
                      icon: 'error',
                      title: 'Terjadi Kesalahan',
                      text: message
                    })
                  } else if (error.request) {
                    Swal.fire({
                      icon: 'error',
                      title: 'Terjadi Kesalahan',
                      text: 'Tidak dapat menyambung ke server'
                    })
                  } else {
                    // eslint-disable-next-line
                    console.log('Something happened in the middle of request')
                  }
                })
                .finally(() => {
                  this.loadingSave = false
                })
            })
          }
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Terjadi Kesalahan',
          text: 'Gagal menyimpan subscription!',
          footer: '<a href>Please contact administrator</a>'
        })
      }
    },

    onCloseButtonClick() {
      this.$emit('close-form')
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-radio {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.detail-date {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label-header {
  color: #222;
}

.tariff-table {
  margin-bottom: 18px;

  &__row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    color: #222;
    padding: 6px 0;

    span:last-child {
      text-align: right;
    }

    &--head {
      font-weight: 500;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    }
  }
}

.detail-input {
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  &__label {
    flex: 1;
    display: flex;
    color: #222;
  }

  &__input-text {
    margin-left: 10px;
    max-width: 60%;
  }
}

input:placeholder-shown {
  font-size: 0.5em;
}
.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>
